var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbnailPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 280,
    height: 400,
    viewBox: "0 0 280 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 400
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 400,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 400,
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(99 214)",
    fill: "#a8a8a8",
    fontSize: 16,
    fontFamily: "Inter-Regular, Inter",
    letterSpacing: "0.011em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 16
  }, "Thumbnail")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(84 206)",
    fill: "#5e5873",
    fontSize: 26,
    fontFamily: "Inter-Regular, Inter",
    letterSpacing: "0.011em",
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "400*280")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(140 181)",
    fill: "#068ecf",
    fontSize: 66,
    fontFamily: "Inter-Regular, Inter"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.75,
    y: 0
  }, "+")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailPlaceholder);
export default __webpack_public_path__ + "static/media/ThumbnailPlaceholder.11731e06a1e69eaefe90b0600167aa5a.svg";
export { ForwardRef as ReactComponent };